import PropTypes from 'prop-types';
import React, { useCallback, useContext } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  RadioGroup,
  Radio,
} from '@fluentui/react-components';
import {
  TRACK_BOTH_VISIT_AND_CONVERSION,
  TRACK_CONVERSION_ONLY,
  TRACK_VISIT_ONLY,
} from './visit-conversion-methods';

export const VisitConversionInput = ({
  combinedControl,
  conversionControl,
  isDisabled,
  onChangeMethod,
  useConversionLift,
  useVisitLift,
  visitControl,
}) => {
  const i18n = useContext(I18nContext);
  const combinedLabel = i18n.getString(_TL_('Measure visit and conversion lift'));
  const conversionLabel = i18n.getString(_TL_('Measure conversion lift only'));
  const visitLabel = i18n.getString(_TL_('Measure visit lift only'));

  let trackingMethod = null;
  if (useConversionLift && useVisitLift) {
    trackingMethod = TRACK_BOTH_VISIT_AND_CONVERSION;
  } else if (useConversionLift) {
    trackingMethod = TRACK_CONVERSION_ONLY;
  } else if (useVisitLift) {
    trackingMethod = TRACK_VISIT_ONLY;
  }

  const onSelectRadio = useCallback((e, { value }) => {
    if (value === TRACK_BOTH_VISIT_AND_CONVERSION) {
      onChangeMethod({
        useConversionLift: true,
        useVisitLift: true,
      });
    } else if (value === TRACK_CONVERSION_ONLY) {
      onChangeMethod({
        useConversionLift: true,
        useVisitLift: false,
      });
    } else {
      onChangeMethod({
        useConversionLift: false,
        useVisitLift: true,
      });
    }
  }, [onChangeMethod]);

  return (
    <RadioGroup
      className="visit-conversion-radio-group"
      disabled={isDisabled}
      onChange={onSelectRadio}
      value={trackingMethod}
    >
      <Radio
        label={combinedLabel}
        value={TRACK_BOTH_VISIT_AND_CONVERSION}
      />
      {trackingMethod === TRACK_BOTH_VISIT_AND_CONVERSION && combinedControl}
      <Radio
        label={conversionLabel}
        value={TRACK_CONVERSION_ONLY}
      />
      {trackingMethod === TRACK_CONVERSION_ONLY && conversionControl}
      <Radio
        label={visitLabel}
        value={TRACK_VISIT_ONLY}
      />
      {trackingMethod === TRACK_VISIT_ONLY && visitControl}
    </RadioGroup>
  );
};

VisitConversionInput.propTypes = {
  combinedControl: PropTypes.node.isRequired,
  conversionControl: PropTypes.node.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onChangeMethod: PropTypes.func.isRequired,
  useConversionLift: PropTypes.bool,
  useVisitLift: PropTypes.bool,
  visitControl: PropTypes.node.isRequired,
};

VisitConversionInput.defaultProps = {
  useConversionLift: false,
  useVisitLift: false,
};
